/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { CallButtonVehicleFragmentDoc } from '../../../../ad-operator-call/src/lib/components/CallButton/CallButton.hook'
import { BookabilityCardVehicleFragmentDoc } from '../../../../ad-telematics-cards/src/lib/BookabilityCard/BookabilityCard.hook'
import { VehicleDrawerStatusBarVehicleFragmentDoc } from '../../../../fleet-maps-common/src/lib/components/Drawer/VehicleDrawerStatusBar.hook'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { AdVehicleDrawerHeaderVehicleFragmentDoc } from './AdVehicleDrawerHeader/AdVehicleDrawerHeader.hook'
import { AdVehicleMenuVehicleFragmentDoc } from './AdVehicleMenu/AdVehicleMenu.hook'

const defaultOptions = {} as const
export type AdFleetMapVehicleDrawerQueryVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  withAdTelemetryData: Types.Scalars['Boolean']['input']
}>

export type AdFleetMapVehicleDrawerQuery = {
  __typename?: 'Query'
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    inService: boolean | null
    label: number | null
    notInServiceReasons: Array<Types.NotInServiceReason> | null
    isSelfDriving: boolean
    isResponsive: boolean | null
    latestADTelemetry: {
      __typename?: 'ADTelemetry'
      sdsMode: {
        __typename?: 'SDSModeWithTimestamp'
        sdsMode: Types.SdsMode
      } | null
      signalConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      cabinConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
      missionConnectivityState: {
        __typename?: 'ADConnectivityStateWithTimestamp'
        connectivityState: Types.AdConnectivityState
        timestamp: string
      } | null
    } | null
    fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
    fccHandledByOperatorDetails: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
    pooling: {
      __typename?: 'Pooling'
      enabled: boolean
      enabledUpdatedAt: string | null
      reason: Types.PoolingReason | null
      connected: boolean | null
      connectedUpdatedAt: string | null
    } | null
    fccCurrentAdAlerts: {
      __typename?: 'FccAdAlerts'
      alerts: Array<{
        __typename?: 'FccAdAlert'
        id: string
        type: Types.FccAdAlertType
        status: Types.FccAdAlertStatus
      }>
    } | null
    fccUpcomingWaypoints: Array<{
      __typename?: 'FccWaypoint'
      adState: Types.FccWaypointState | null
      actions: Array<
        | {
            __typename: 'FccWaypointDeliveryAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | { __typename: 'FccWaypointHubReturnAction'; id: string }
        | {
            __typename: 'FccWaypointPickupAction'
            id: string
            estimatedAt: string
            pickedUpAt: string | null
            adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
            notShownUpAt: string | null
            tripIsCancelled: boolean | null
            trip: { __typename?: 'Trip'; id: string } | null
            customer: {
              __typename?: 'Customer'
              firstName: string | null
              lastName: string | null
              extendedWalkingTime: boolean
              visualImpairment: boolean | null
            } | null
            ridePassengerInfo: {
              __typename?: 'FccRidePassengerInfo'
              customerId: string | null
              displayName: string | null
              boardingRequirements: {
                __typename?: 'FccBoardingRequirements'
                headCount: number
                childSeat: boolean
                wheelchair: boolean
              } | null
              impairments: {
                __typename?: 'FccImpairments'
                visual: boolean
              } | null
            } | null
          }
        | { __typename: 'FccWaypointReallocationAction' }
      >
      fccStop: {
        __typename?: 'FccStop'
        id: string | null
        names: Partial<Record<'de' | 'en' | 'no', string>>
      } | null
      stopWithServiceArea: {
        __typename?: 'Stop'
        id: string
        serviceArea: { __typename?: 'ServiceArea'; id: string }
      } | null
    }> | null
    fleet: { __typename?: 'Fleet'; id: string } | null
    region: { __typename?: 'Region'; id: string } | null
  }
}

export const AdFleetMapVehicleDrawerDocument = gql`
    query adFleetMapVehicleDrawer($vehicleId: ID!, $withAdTelemetryData: Boolean!) {
  vehicle: vehicleByID(id: $vehicleId) {
    id
    latestADTelemetry {
      sdsMode {
        sdsMode
      }
    }
    ...AdVehicleDrawerHeaderVehicle
    ...VehicleDrawerStatusBarVehicle
    ...AdVehicleMenuVehicle
    ...CallButtonVehicle
    ...BookabilityCardVehicle
  }
}
    ${AdVehicleDrawerHeaderVehicleFragmentDoc}
${VehicleDrawerStatusBarVehicleFragmentDoc}
${AdVehicleMenuVehicleFragmentDoc}
${CallButtonVehicleFragmentDoc}
${BookabilityCardVehicleFragmentDoc}`

/**
 * __useAdFleetMapVehicleDrawerQuery__
 *
 * To run a query within a React component, call `useAdFleetMapVehicleDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdFleetMapVehicleDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdFleetMapVehicleDrawerQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      withAdTelemetryData: // value for 'withAdTelemetryData'
 *   },
 * });
 */
export function useAdFleetMapVehicleDrawerQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdFleetMapVehicleDrawerQuery,
    AdFleetMapVehicleDrawerQueryVariables
  > &
    (
      | { variables: AdFleetMapVehicleDrawerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdFleetMapVehicleDrawerQuery,
    AdFleetMapVehicleDrawerQueryVariables
  >(AdFleetMapVehicleDrawerDocument, options)
}
export function useAdFleetMapVehicleDrawerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdFleetMapVehicleDrawerQuery,
    AdFleetMapVehicleDrawerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdFleetMapVehicleDrawerQuery,
    AdFleetMapVehicleDrawerQueryVariables
  >(AdFleetMapVehicleDrawerDocument, options)
}
// @ts-ignore
export function useAdFleetMapVehicleDrawerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AdFleetMapVehicleDrawerQuery,
    AdFleetMapVehicleDrawerQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AdFleetMapVehicleDrawerQuery,
  AdFleetMapVehicleDrawerQueryVariables
>
export function useAdFleetMapVehicleDrawerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdFleetMapVehicleDrawerQuery,
        AdFleetMapVehicleDrawerQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AdFleetMapVehicleDrawerQuery | undefined,
  AdFleetMapVehicleDrawerQueryVariables
>
export function useAdFleetMapVehicleDrawerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdFleetMapVehicleDrawerQuery,
        AdFleetMapVehicleDrawerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdFleetMapVehicleDrawerQuery,
    AdFleetMapVehicleDrawerQueryVariables
  >(AdFleetMapVehicleDrawerDocument, options)
}
export type AdFleetMapVehicleDrawerQueryHookResult = ReturnType<
  typeof useAdFleetMapVehicleDrawerQuery
>
export type AdFleetMapVehicleDrawerLazyQueryHookResult = ReturnType<
  typeof useAdFleetMapVehicleDrawerLazyQuery
>
export type AdFleetMapVehicleDrawerSuspenseQueryHookResult = ReturnType<
  typeof useAdFleetMapVehicleDrawerSuspenseQuery
>
export type AdFleetMapVehicleDrawerQueryResult = Apollo.QueryResult<
  AdFleetMapVehicleDrawerQuery,
  AdFleetMapVehicleDrawerQueryVariables
>
